// extracted by mini-css-extract-plugin
export default {"wrapper":"MinerStatusesModal_wrapper__4sMK7"};